import { useQuery } from "@msuite/ui/query";
import { DataTable, type DataTableProps } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { client } from "@/hono";
import { columns } from "./table-config";

/** Props Interface */
interface SuborderArticlesTableProps {
	orderId: string;
	suborderId: string;
	variant?: DataTableProps<any>["variant"];
}

export function SuborderArticlesTable({
	orderId,
	suborderId,
	variant = "sub-table",
}: SuborderArticlesTableProps) {
	const { data, queryKey, isLoading, refetch } = useQuery({
		queryKey: ["suborder-articles", suborderId],
		queryFn: async () => {
			const response = await client.stock.orders[":orderId"].suborders[":suborderId"].articles.$get(
				{ param: { orderId, suborderId } },
			);
			const data = await responseHandler(response);
			return data.suborderArticles;
		},
	});

	/** Render */
	return (
		<DataTable
			variant={variant}
			data={guardArray(data)}
			columns={columns as any}
			persistenceKey="suborder-articles-table"
			isLoading={isLoading}
			queryKey={queryKey}
			refetch={refetch}
			menu={null}
		/>
	);
}
